export const environment = {
  production: true,
  forceDomainBrand: null as 'mega-ca' | 'mega-inc' | 'sigma-industrial' | null,
};
